import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Heart, Users, BookOpen, Shield, Handshake} from 'lucide-react'

const impactos = [
  { icon: Users, title: "Jovens atendidos", text: "Dezenas de jovens em processo de ressocialização já foram beneficiados com acesso completo ao EW Pass.", color: "#0E8EA0" },
  { icon: BookOpen, title: "Educação como ponte", text: "O inglês se torna uma ferramenta de inclusão, abrindo portas para o mercado de trabalho e novas oportunidades.", color: "#B038B2" },
  { icon: Shield, title: "Ressocialização", text: "A educação é a base para a reintegração social, oferecendo perspectivas reais de futuro.", color: "#F5C542" },
  { icon: Heart, title: "Transformação de vidas", text: "Cada jovem que aprende inglês através do projeto é uma história de superação e esperança.", color: "#6CC4C4" },
]

export default function InstitutoPonte() {
  const section1 = useScrollReveal()
  const section2 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Projetos Sociais — Instituto Ponte"
        subtitle="Uma parceria que transforma vidas através da educação em inglês."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <div className="max-w-3xl mx-auto text-center mb-14">
            <div
              className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
              style={{ backgroundColor: "#0E8EA015" }}
            >
              <Handshake size={36} style={{ color: "#0E8EA0" }} />
            </div>
            <p className="text-gray-600 leading-relaxed mb-4">
              A English Work mantém uma parceria especial com o Instituto Ponte, organização dedicada à ressocialização e inclusão de jovens em situação de vulnerabilidade.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Através dessa parceria, oferecemos acesso completo ao EW Pass para jovens atendidos pelo Instituto, utilizando a educação em inglês como ferramenta de transformação social e inclusão no mercado de trabalho.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20" style={{ backgroundColor: "#F8F9FA" }}>
        <div
          ref={section2.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" style={{ color: "#0E8EA0" }}>
            Impacto da parceria
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {impactos.map((item) => (
              <div
                key={item.title}
                className="bg-white rounded-2xl p-7 border border-gray-100 hover:shadow-lg transition-all duration-300 group"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform"
                  style={{ backgroundColor: `${item.color}15` }}
                >
                  <item.icon size={26} style={{ color: item.color }} />
                </div>
                <h3 className="text-lg font-bold mb-3 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
